import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { registerLocaleData } from '@angular/common';
import localeDE from '@angular/common/locales/de';
import localeEN from '@angular/common/locales/en';
// esbuild bundelt die dynamischen moment-Locale-Requires nicht (frueher hielt
// das moment-locales-Webpack-Plugin nur 'de' vor) -> explizit importieren.
import 'moment/locale/de';

import { msalInstance } from '../auth-config';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import { hmrBootstrap } from './hmr';

declare const module: any;

registerLocaleData(localeDE);
registerLocaleData(localeEN);

if (environment.production) {
  enableProdMode();
}

// msal-browser v5: Instanz muss initialisiert sein, bevor irgendwo
// getAllAccounts()/getActiveAccount() aufgerufen wird (z.B. MenuService-
// Konstruktor). Deshalb initialize() strikt VOR dem Angular-Bootstrap.
const bootstrap = () =>
  msalInstance.initialize().then(() =>
    platformBrowserDynamic().bootstrapModule(AppModule, {
      applicationProviders: [provideZoneChangeDetection()],
    })
  );

if (environment.hmr) {
  if (module.hot) {
    hmrBootstrap(module, bootstrap);
  } else {
    console.error('HMR is not enabled for webpack-dev-server!');
    console.log('Are you using the --hmr flag for ng serve?');
  }
} else {
  bootstrap().catch(error => console.error(error));
}
